import React, { useContext, useEffect, useState } from "react";
import Input from "../../../../components/input";
import Icon from "@material-ui/core/Icon";
import { AuthContext } from "../../../../auth-context";
import AVNSelect from "../../../../components/select";
import Modal from "../../../../components/modal";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableHeadRow,
  TableBodyRow,
  HeadCell,
  DataCell,
} from "../../../../components/table";

export const SelectUsers = ({
  heading,
  currentSelected,
  submit,
  open,
  onClose,
}) => {
  const { user } = useContext(AuthContext);
  const [checkAll, updateCheckAll] = useState(false);
  const [potentialRecipients, updatePotentialRecipients] = useState([]);
  const [filterText, updateFilterText] = useState("");
  const [filterTrainer, setFilterTrainer] = useState({
    label: "All",
    value: 0,
  });
  const [filterGroup, setFilterGroup] = useState({ label: "All", value: 0 });
  const [selected, setSelected] = useState([]);

  const effectiveHeading = heading || "Select recipients to be added.";

  useEffect(() => {
    let newPotentialRecipients = [];
    user.accounts.forEach((a) => {
      if (
        a.user_id !== null &&
        (user.role_id === 1 || user.role_id === 2 || a.trainers.includes(user.id)) &&
        a.trainer_permission === 1
      ) {
        let already = false;
        for (let n = 0; n < currentSelected.length; ++n) {
          if (currentSelected[n].id === a.id) {
            already = true;
            break;
          }
        }
        if (!already) {
          newPotentialRecipients.push({
            id: a.id,
            email_address: a.email_address,
            name: a.name,
            trainers: a.trainers,
            groups: a.groups,
          });
        }
      }
    });
    newPotentialRecipients.sort((x, y) => {
      let result = 0;
      if (x.name < y.name) {
        result = -1;
      } else if (x.name < y.name) {
        result = 1;
      }
      return result;
    });
    updatePotentialRecipients(newPotentialRecipients);
  }, [open, currentSelected, user.accounts, user.id]);

  useEffect(() => {
    if (!open) {
      setSelected([]);
    }
  }, [open]);

  const selectFilter = (x) => {
    const lcFilterText = filterText.toLowerCase();
    return (
      (filterText === "" ||
        x.name.toLowerCase().indexOf(lcFilterText) !== -1 ||
        x.email_address.toLowerCase().indexOf(lcFilterText) !== -1) &&
      (filterTrainer.value === 0 || x.trainers.includes(filterTrainer.value)) &&
      (filterGroup.value === 0 || x.groups.includes(filterGroup.value))
    );
  };

  const handleCheckAllClick = () => {
    let newSelected;
    let newCheckAll;
    if (checkAll) {
      newSelected = [];
      newCheckAll = false;
    } else {
      newSelected = potentialRecipients.filter(selectFilter).map((r) => r.id);
      newCheckAll = true;
    }
    setSelected(newSelected);
    updateCheckAll(newCheckAll);
  };

  const handleCheckboxClick = (account_id) => {
    let newSelected = selected.slice(0);
    const index = newSelected.findIndex((s) => s === account_id);
    if (index === -1) {
      newSelected.push(account_id);
    } else {
      newSelected.splice(index, 1);
    }
    setSelected(newSelected);
  };

  const handleSubmit = () => {
    submit(selected);
  };

  const trainerOptions = [
    { label: "All", value: 0 },
    ...user.team.map((item) => ({ label: item.name, value: item.id })),
  ];
  const groupOptions = [
    { label: "All", value: 0 },
    ...user.groups.map((item) => ({ label: item.name, value: item.id })),
  ];

  return (
    <>
      <Modal
        title="Select Clients"
        onClose={onClose}
        open={open}
        maxWidth="lg"
        handleSubmit={handleSubmit}
        submitLabel="Save"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            gap: "10px",
          }}
        >
          <div style={{ flex: 1 }}>
            <Input
              label={"Filter by name or email address"}
              value={filterText}
              onChange={updateFilterText}
            />
          </div>
          <div style={{ flex: 1 }}>
            <AVNSelect
              options={trainerOptions}
              value={filterTrainer}
              onChange={(val) => setFilterTrainer(val)}
              label="Filter by trainer"
            />
          </div>
          <div style={{ flex: 1 }}>
            <AVNSelect
              options={groupOptions}
              value={filterGroup}
              onChange={(val) => setFilterGroup(val)}
              label="Filter by group"
            />
          </div>
        </div>
        <div style={{ margin: "20px 0 10px 0" }}>
          <label>{effectiveHeading}</label>
        </div>
        <TableContainer>
          <Table>
            <TableHead>
              <TableHeadRow>
                <HeadCell>
                  <Icon
                    className="material-icons"
                    onClick={() => handleCheckAllClick()}
                    style={{
                      color: checkAll ? "#14ab40" : "#5a5a5a",
                      cursor: "pointer",
                    }}
                  >
                    {checkAll ? "check_circle" : "radio_button_unchecked"}
                  </Icon>
                </HeadCell>
                <HeadCell>Email Address</HeadCell>
                <HeadCell>Full Name</HeadCell>
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {potentialRecipients.filter(selectFilter).map((item, index) => {
                return (
                  <TableBodyRow key={index}>
                    <DataCell>
                      <Icon
                        className="material-icons"
                        onClick={() => handleCheckboxClick(item.id)}
                        style={{
                          color: selected.includes(item.id)
                            ? "#14ab40"
                            : "#5a5a5a",
                        }}
                      >
                        {selected.includes(item.id)
                          ? "check_circle"
                          : "radio_button_unchecked"}
                      </Icon>
                    </DataCell>
                    <DataCell>{item.email_address}</DataCell>
                    <DataCell>{item.name}</DataCell>
                  </TableBodyRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Modal>
    </>
  );
};
